import {KeycloakService} from 'keycloak-angular';
import {environment} from '../../environments/environment';

export function initializer(keycloak: KeycloakService): () => Promise<any> {
  return (): Promise<void> => {
    return new Promise(async (resolve, reject) => {
      try {
        await keycloak.init({
          config: {
            url: environment.keycloak.issuer,
            realm: environment.keycloak.realm,
            clientId: environment.keycloak.clientId
          },
          loadUserProfileAtStartUp: false,
          initOptions: {
            onLoad: 'login-required',
            checkLoginIframe: false,
            useNonce: false, // KC26 nem teszi a nonce-t az access tokenbe, a keycloak-js 18 meg ellenorzi -> login loop; a state adja a CSRF-vedelmet
          },
          enableBearerInterceptor: true,
          bearerExcludedUrls: ['https://management-rvc.pitunnel.com/api/data']
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  };
}

